export const CommonButtonVariants = {
  PRIMARY: 'primary',
  PRIMARY_RED: 'primary-red',
  SECONDARY: 'secondary',
  DISABLED: 'disabled',
  ORGANIZATION_NAV: 'organization-nav',
  AUCTION: 'auction',
  SUCCESS: 'success',
  DANGER: 'danger',
  GREY: 'grey',
  PUBLISH: 'publish',
  CAR_FEATURE: 'feature',
  CAR_FEATURE_SELECTED: 'feature--selected',
  DELETE: 'delete',
  OUTLINED: 'outlined',
  OUTLINED_WHITE: 'outlined-white',
  RED: 'red',
  OUTLINED_RED: 'outlined-red',
  LIVE: 'live',
  SOLD: 'sold',
  CANCELLED: 'cancelled',
  DRAFT: 'draft',
};

export const CommonButtonSize = {
  DEFAULT: 'default',
  LARGE: 'large',
  SMALL: 'small',
  MEDIUM: 'medium',
};
